import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['title'];

  connect() {
    this.update();
  }

  update() {
    const hasDash = /[-–, ]/.test(this.titleTarget.value);
    this.titleTarget.classList.toggle('nw-admin__title-input--has-hyphen', hasDash);
  }
}
